import React, {useEffect, useState} from "react";
import {exibirMensagemErro, xfetch, HttpVerbo, formatarDinheiroItl} from "../../util";
import {Link} from "react-router-dom";
import BarraProgresso from '../barra-progresso/barra-progresso';
import CardPadrao from '../card/card-padrao';
import {Meta} from "../../tipos/meta";
import {BotaoMantine} from "../botao/botao-mantine";
import {ICONE} from "../../config/constantes/constantes-mantine";
import {Group, Table} from "@mantine/core";

interface MetasProjetoProps {
  setIsCarregando: any,
  idProjeto: string,
  isFundoAFundo: boolean
}

export default function MetasProjeto(props: MetasProjetoProps) {

  const [metas, setMetas] = useState<Meta[]>([])

  function carregarMetas() {
    props.setIsCarregando(true)
    xfetch('/projeto/' + props.idProjeto + '/metas', {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(data => {
        setMetas(data)
        props.setIsCarregando(false)
      })
      .catch(err => {
        props.setIsCarregando(false)
        setMetas([])
        exibirMensagemErro("Erro ao carregar metas do projeto - " + err.messsage)
      })
  }

  useEffect(() => {
    carregarMetas()
  }, [])

  let descricaoBotao = props.isFundoAFundo ? "Novo eixo" : "Nova meta"
  let descricaoCard = props.isFundoAFundo ? "Eixos" : "Metas"

  const botaoNovaMeta = <Link to={`/projeto/${props.idProjeto}/novaMeta`}>
    <BotaoMantine icone={ICONE.ADICIONAR} size={"xs"}>
      {descricaoBotao}
    </BotaoMantine>
  </Link>;

  function getValores1(m:  Meta) {
    if (props.isFundoAFundo) {
      return (
        <>
          <Group> Valor inicial - {formatarDinheiroItl(m.valorCusteio)}</Group>
          <Group>Rendimento - {formatarDinheiroItl(m.valorRendimentoCusteio)}</Group>
        </>)
    } else return formatarDinheiroItl(m.valorEstimado)
  }

  function getValores2(m:  Meta) {
    if (props.isFundoAFundo) {
      return (
        <>
          <Group> Valor inicial - {formatarDinheiroItl(m.valorCapital)}</Group>
          <Group>Rendimento - {formatarDinheiroItl(m.valorRendimentoCapital)}</Group>
        </>)
    } else return <BarraProgresso percentual={m.percentualExecutado} tamanho={28} w={250} />
  }

  return (
    <CardPadrao titulo={descricaoCard} botao={botaoNovaMeta}>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Nome</Table.Th>
            <Table.Th>Valor {props.isFundoAFundo ? "Custeio" : "Estimado"}</Table.Th>
            <Table.Th >Valor {props.isFundoAFundo ? "Capital" : "Executado"}</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {metas.map((m, k) => {
            return (
              <Table.Tr key={k}>
                <Table.Td>
                  <Link to={`/projeto/${props.idProjeto}/meta/${m.id}`}>
                    {m.descricao}
                  </Link></Table.Td>
                <Table.Td>
                  {getValores1(m)}
                </Table.Td>
                <Table.Td>
                  {getValores2(m)}
                </Table.Td>
              </Table.Tr>
            )
          })}
        </Table.Tbody>
      </Table>
    </CardPadrao>
  )
}